<script setup>
import { inject, computed } from "vue";
import { useStore } from "vuex";
import { cn } from "@/lib/utils";
import { useRouter } from "vue-router";
import { IconBuildings, IconTicket, IconUser } from "@tabler/icons-vue";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import urlTemp from "@/constants/urlTemp";

defineProps({
  title: String,
  data: Array,
});

const store = useStore();
const appId = computed(() => store.getters["appId"]?.hashed);
const router = useRouter();

const icon = {
  project: IconBuildings,
  tickets: IconTicket,
  customer: IconUser,
};

const viewAll = {
  project: null,
  tickets: "ticketing.tickets.tickets-list",
  customer: "omni.customers.list",
};

const redirect = computed(() => ({
  project: async (app) => {
    store.commit("app/ADD_RECENT_SEARCHES", searchValue.value);
    store.dispatch("bot/getActiveBot", app.hashed_id);
    window.location.href = `${urlTemp.value}/${app.hashed_id}/dashboard`;
  },
  customer: (cus) =>
    router.push({
      name: "omni.customers.panel",
      params: {
        customer_id: cus.hashed_id,
        appId: store.getters.appId.hashed,
      },
    }),
  tickets: (tix) =>
    router.push({
      name: "ticketing.manage.edit",
      params: {
        ticketId: tix.id,
        appId: store.getters.appId.hashed,
      },
    }),
}));

const isLoading = inject("isLoading");
const searchValue = inject("searchValue");
</script>

<template>
  <div class="vf-mt-4">
    <div class="vf-flex vf-justify-between vf-w-full">
      <h6 class="vf-text-neutral-400 vf-uppercase">
        {{ title }}
      </h6>
      <a
        v-if="viewAll[title.toLowerCase()]"
        :href="
          router.resolve({
            name: viewAll[title.toLowerCase()],
            params: {
              appId,
            },
            query: {
              filter: searchValue,
            },
          }).href
        "
        ><span class="vf-text-xs vf-text-info-500"> View all </span></a
      >
    </div>
    <ul class="vf-pt-2" v-if="data?.length && !isLoading">
      <li v-for="item in data" :key="item">
        <Button
          @click="redirect[title?.toLowerCase()](item)"
          variant="ghost"
          class="vf-w-full !vf-justify-start !vf-items-start hover:vf-bg-neutral-100 !vf-h-auto vf-flex vf-gap-x-3 vf-p-2"
        >
          <component
            :is="icon[title?.toLowerCase()]"
            size="16"
            :color="item.iconColor"
            class="vf-translate-y-1"
          />
          <span class="vf-flex vf-flex-col vf-items-start">
            <span class="vf-text-left">{{ item.name }}</span>
            <span
              class="vf-text-neutral-400 vf-text-xs vf-flex vf-items-center"
            >
              <template v-for="item in item.subdesc" :key="item"
                ><p
                  :class="
                    cn('vf-mx-0.5', item.includes('@') && 'vf-text-primary-500')
                  "
                >
                  {{ item }}
                </p>
              </template></span
            >
          </span>
        </Button>
      </li>
    </ul>
    <div v-if="isLoading" class="flex-center vf-h-[200px]">
      <BeatLoader color="var(--primary-500)" size="12px" />
    </div>
    <div
      v-if="!isLoading && data?.length === 0"
      class="flex-center vf-h-[200px]"
    >
      <h5 class="vf-text-neutral-400">NO DATA</h5>
    </div>
  </div>
</template>
